import React from 'react';
import { useDispatch } from 'react-redux';

import { InfoCard } from '~/eds/src/components/Card/subcomponents/InfoCard';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { AutomationStageType } from '~/enums/AutomationStageType';
import { useIntl } from 'react-intl';
import { slices } from '~/redux/slices';

const AutomationTypes = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  return (
    <Layout align="center" alignSelf="center">
      <ContentContainer>
        <Layout direction="column" preset="cards">
          <InfoCard
            title={intl.formatMessage({
              id: 'AutomationTypes.quickAiFormTitle',
              defaultMessage: 'AI for Standard Clauses',
              description: 'Title for quick AI form automation type',
            })}
            description={intl.formatMessage({
              id: 'AutomationTypes.quickAiFormDescription',
              defaultMessage:
                'A quick way to find standard language in your contracts.',
              description: 'Description for quick AI form automation type',
            })}
            action={{
              text: intl.formatMessage({
                id: 'AutomationTypes.quickAiFormAction',
                defaultMessage: 'Get Started',
                description: 'Action text for quick AI form automation type',
              }),
              onClick: () =>
                dispatch(
                  slices.automation.actions.setAutomationManageStage(
                    AutomationStageType.QuickAiForm,
                  ),
                ),
            }}
          />
          <InfoCard
            title={intl.formatMessage({
              id: 'AutomationTypes.guidedAiFormTitle',
              defaultMessage: 'AI for Non-standard Clauses',
              description: 'Title for guided AI form automation type',
            })}
            description={intl.formatMessage({
              id: 'AutomationTypes.guidedAiFormDescription',
              defaultMessage:
                'Use this when you have non-standard language or need more control over the process.',
              description: 'Description for guided AI form automation type',
            })}
            action={{
              text: intl.formatMessage({
                id: 'AutomationTypes.guidedAiFormAction',
                defaultMessage: 'Get Started',
                description: 'Action text for guided AI form automation type',
              }),
              onClick: () =>
                dispatch(
                  slices.automation.actions.setAutomationManageStage(
                    AutomationStageType.GuidedAiForm,
                  ),
                ),
            }}
          />
        </Layout>
      </ContentContainer>
    </Layout>
  );
};

export default AutomationTypes;
